import { useState } from "react";
import { Button, Col, Form, Input, Row, Select, Spin } from "antd";

import AppCard from "../../components/AppCard";

const CreateDiagnosis = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = (value) => {
    setLoading(false)
    console.log(value);
  };

  return (
    <Spin spinning={loading}>
      <AppCard heading="Create Diagnosis">
        <Form onFinish={onFinish} form={form} layout="vertical">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="system" label="Select System" rules={[{ required: true, message: "Please enter system name" }]}>
                <Select />
                <Select.Option></Select.Option>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="organ" label="Select Organ" rules={[{ required: true, message: "Please enter system name" }]}>
                <Select />
                <Select.Option></Select.Option>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} lg={8}>
              <Form.Item name="diagnosis" label="Diagnosis Name" rules={[{ required: true, message: "Please enter system name" }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <div className="center">
            <Button type="primary" htmlType="submit">
              Create Diagnosis
            </Button>
          </div>
        </Form>
      </AppCard>
    </Spin>
  );
};

export default CreateDiagnosis;
